import React, { useEffect } from "react";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { useRouteMatch } from "react-router-dom";
import Collapse from "@material-ui/core/Collapse";
import SettingsCellIcon from "@material-ui/icons/SettingsCell";
import SimCardIcon from "@material-ui/icons/SimCard";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import MobileScreenShareIcon from "@material-ui/icons/MobileScreenShare";
import AssignmentIcon from "@material-ui/icons/Assignment";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import DashboardIcon from "@material-ui/icons/Dashboard";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import PaymentIcon from "@material-ui/icons/Payment";
import HeadsetIcon from "@material-ui/icons/Headset";
import SendIcon from "@material-ui/icons/Send";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import TrendingFlatIcon from "@material-ui/icons/TrendingFlat";
import TollIcon from "@material-ui/icons/Toll";
import CompareIcon from "@material-ui/icons/Compare";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import ReceiptIcon from "@material-ui/icons/Receipt";
import StoreRoundedIcon from "@material-ui/icons/StoreRounded";
import MenuOption from "../components/shared/LeftMenuOptions";
import { AuthService } from "../services/auth.service";
import { Role } from "../_utils/roleEnum";

const drawerWidth = 180;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  rootDrawer: {
    span: {
      color: theme.palette.secondary,
      fontWeight: "700 !important",
      fontSize: 30,
    },
  },
  mainTitle: {
    margin: "20px 0px -30px 10px",
    textAlign: "center",
    fontWeight: 900,
  },

  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginTop: -100,
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    background:
      "transparent linear-gradient(0deg, rgba(24,30,112,0.9094012605042017) 2%, rgba(88,186,255,1) 92%) 0% 0% no-repeat padding-box",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  nested: {
    paddingLeft: theme.spacing(2),
    textDecoration: "none !important",
  },
}));

function LeftMenuLayout() {
  const classes = useStyles();
  const { url } = useRouteMatch();

  /**Collapsible option */
  const [openInventory, setOpenInventory] = React.useState(false);
  const [openSells, setOpenSells] = React.useState(false);
  const [openInventorySeller, setOpenInventorySeller] = React.useState(false);

  const [userRole, setUserRole] = React.useState(undefined);
  const [siteId, setSiteId] = React.useState(1);

  useEffect(() => {
    //const currentToken = AuthService.currentUserToken;
    const currentUserValue = AuthService.currentUserValue;
    setUserRole(currentUserValue.roleId);
    setSiteId(currentUserValue.siteId);
  }, []);

  const title = (
    <Typography variant="h6" color="secondary" className={classes.mainTitle}>
      Telcel Sierra Movil
    </Typography>
  );

  const showExpandIcon = openInventory ? (
    <ExpandLess color="secondary" />
  ) : (
    <ExpandMore color="secondary" />
  );

  const showExpandSellIcon = openSells ? (
    <ExpandLess color="secondary" />
  ) : (
    <ExpandMore color="secondary" />
  );

  const showExpandSellerIcon = openInventorySeller ? (
    <ExpandLess color="secondary" />
  ) : (
    <ExpandMore color="secondary" />
  );

  const handleCollapsibleIcon = (collapsibleOption) => {
    switch (collapsibleOption) {
      case 0:
        setOpenInventory(!openInventory);
        break;
      case 1:
        setOpenSells(!openSells);
        break;
      case 2:
        setOpenInventorySeller(!openInventorySeller);
        break;
      default:
        setOpenInventory(!openInventory);
        break;
    }
  };

  return (
    <React.Fragment>
      {title}
      {userRole !== undefined && (
        <div className={classes.rootDrawer}>
          <div className={classes.toolbar} />
          <Divider />
          <List component="div" aria-label="main mailbox folders">
            <MenuOption
              name="Dashboard"
              idOption={0}
              url={url}
              icon={<DashboardIcon color="secondary"></DashboardIcon>}
            />
            {(userRole === Role.Admin ||
              userRole === Role.ManagerAccesory ||
              userRole === Role.ManagerMovile) && (
              <>
                <MenuOption
                  name="Inventario"
                  icon={<LocationCityIcon color="secondary" />}
                  showExpandIcon={showExpandIcon}
                  changeIcon={handleCollapsibleIcon}
                />
                <Collapse
                  in={openInventory}
                  timeout="auto"
                  unmountOnExit
                  className={classes.nested}
                >
                  <MenuOption
                    disablePadding
                    name="Equipo móvil"
                    idOption={1}
                    url={`${url}/inventario/moviles`}
                    icon={<SettingsCellIcon color="secondary" />}
                  />
                  <MenuOption
                    disablePadding
                    name="Accesorios"
                    idOption={2}
                    url={`${url}/inventario/accesorios`}
                    icon={<HeadsetIcon color="secondary" />}
                  />
                  <MenuOption
                    disablePadding
                    name="Chips"
                    idOption={3}
                    url={`${url}/inventario/chips`}
                    icon={<SimCardIcon color="secondary" />}
                  />
                  <MenuOption
                    disablePadding
                    name="Tarjeta de saldo"
                    idOption={4}
                    url={`${url}/inventario/tarjetas-saldo`}
                    icon={<PaymentIcon color="secondary" />}
                  />
                  <MenuOption
                    disablePadding
                    name="Distribución"
                    idOption={5}
                    url={`${url}/inventario/distribucion`}
                    icon={<SwapHorizIcon color="secondary" />}
                  />
                  <MenuOption
                    disablePadding
                    name="Comparativo"
                    idOption={6}
                    url={`${url}/inventario/comparativo`}
                    icon={<CompareIcon color="secondary" />}
                  />
                </Collapse>

                <MenuOption
                  name="Ventas"
                  disablePadding
                  idOption={7}
                  url={`${url}/ventas`}
                  icon={<SettingsCellIcon color="secondary" />}
                />
              </>
            )}

            {(userRole === Role.Admin || userRole === Role.GuaranteeHelper) && (
              <MenuOption
                disablePadding
                name="Garantias"
                idOption={8}
                url={`${url}/garantias`}
                icon={<ReceiptIcon color="secondary" />}
              />
            )}

            {(userRole === Role.Admin ||
              userRole === Role.ManagerAccesory ||
              userRole === Role.ManagerMovile) && (
              <>
                <MenuOption
                  disablePadding
                  name="Sucursales"
                  idOption={9}
                  url={`${url}/sucursales`}
                  icon={<StoreRoundedIcon color="secondary" />}
                />
                <MenuOption
                  disablePadding
                  name="Usuarios"
                  idOption={10}
                  url={`${url}/usuarios`}
                  icon={<PersonRoundedIcon color="secondary" />}
                />
              </>
            )}
            {userRole === Role.Admin && (
              <MenuOption
                disablePadding
                name="Gastos"
                idOption={11}
                url={`${url}/gastos`}
                icon={<LocalAtmIcon color="secondary" />}
              />
            )}

            {userRole === Role.Admin && (
              <MenuOption
                disablePadding
                name="Distrib. Global"
                idOption={12}
                url={`${url}/distribucion-global`}
                icon={<LocalShippingIcon color="secondary" />}
              />
            )}

            {/** Selller section */}
            {userRole === Role.Seller && (
              <>
                <MenuOption
                  disablePadding
                  name="Inventarios"
                  icon={<LocationCityIcon color="secondary" />}
                  showExpandIcon={showExpandSellerIcon}
                  changeIcon={handleCollapsibleIcon}
                />
                <Collapse
                  in={openInventorySeller}
                  timeout="auto"
                  unmountOnExit
                  className={classes.nested}
                >
                  <MenuOption
                    disablePadding
                    name="Equipos moviles"
                    idOption={14}
                    url={`${url}/inventario/moviles/sucursal`}
                    icon={<SettingsCellIcon color="secondary" />}
                  />
                  <MenuOption
                    disablePadding
                    name="Accesorios"
                    idOption={15}
                    url={`${url}/inventario/accesorios/sucursal`}
                    icon={<HeadsetIcon color="secondary" />}
                  />
                  <MenuOption
                    disablePadding
                    name="Chips"
                    idOption={16}
                    url={`${url}/inventario/chips/sucursal`}
                    icon={<SimCardIcon color="secondary" />}
                  />
                  <MenuOption
                    disablePadding
                    name="Tarjeta de saldo"
                    idOption={17}
                    url={`${url}/inventario/tarjetas-saldo/sucursal`}
                    icon={<PaymentIcon color="secondary" />}
                  />
                  <MenuOption
                    disablePadding
                    name="Traspasos"
                    idOption={18}
                    url={`${url}/inventario/traspasos/sucursal`}
                    icon={<MobileScreenShareIcon color="secondary" />}
                  />
                  <MenuOption
                    disablePadding
                    name="Planes"
                    idOption={20}
                    url={`${url}/inventario/planes/sucursal`}
                    icon={<AssignmentIcon color="secondary" />}
                  />
                </Collapse>

                <MenuOption
                  disablePadding
                  name="Ventas"
                  icon={<AttachMoneyIcon color="secondary" />}
                  showExpandIcon={showExpandSellIcon}
                  changeIcon={handleCollapsibleIcon}
                />
                <Collapse
                  in={openSells}
                  timeout="auto"
                  unmountOnExit
                  className={classes.nested}
                >
                  <MenuOption
                    disablePadding
                    name="Nueva Venta"
                    idOption={21}
                    url={`${url}/inventario/nueva-venta`}
                    icon={<TrendingFlatIcon color="secondary" />}
                  />
                  <MenuOption
                    disablePadding
                    name="Mis ventas"
                    idOption={22}
                    url={`${url}/inventario/mis-ventas`}
                    icon={<TollIcon color="secondary" />}
                  />
                  <MenuOption
                    disablePadding
                    name="Todas las ventas"
                    idOption={23}
                    url={`${url}/inventario/ventas/sucursal`}
                    icon={<TrendingUpIcon color="secondary" />}
                  />
                </Collapse>
                <MenuOption
                  disablePadding
                  name="Garantías"
                  idOption={24}
                  url={`${url}/inventario/garantias`}
                  icon={<ReceiptIcon color="secondary" />}
                />
                <MenuOption
                  disablePadding
                  name="Distribuciones"
                  idOption={26}
                  url={`${url}/inventario/distribuciones/sucursal`}
                  icon={<SendIcon color="secondary" />}
                />
                <MenuOption
                  disablePadding
                  name="Gastos"
                  idOption={27}
                  url={`${url}/inventario/gastos/sucursal`}
                  icon={<LocalAtmIcon color="secondary" />}
                />
              </>
            )}

            <Divider />
          </List>
        </div>
      )}
    </React.Fragment>
  );
}

export default LeftMenuLayout;
